"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandFactory = void 0;
const regex_1 = require("../../common/regex");
const commandClassMap_1 = require("./lib/commandClassMap");
const types_1 = require("./types");
class CommandFactory {
    static fromLine(line, canParseNotes, strict = true) {
        line = line.trim();
        if (line.length === 0) {
            return undefined;
        }
        if (!line.startsWith('#') && canParseNotes) {
            return types_1.NoteSequence.parse([line], strict);
        }
        const components = line.split(regex_1.SPACE_REGEX);
        const command = components[0].substring(1);
        const args = components.slice(1);
        if (!Object.keys(commandClassMap_1.commandClassMap).includes(command)) {
            return undefined;
        }
        const commandClass = commandClassMap_1.commandClassMap[command];
        if (commandClass === types_1.BranchMarkerCommand) {
            return commandClass.parse(command);
        }
        else {
            return commandClass.parse(args, strict);
        }
    }
}
exports.CommandFactory = CommandFactory;
